module.exports = {"621026100":"新宁镇","621026101":"平子镇","621026102":"早胜镇","621026103":"长庆桥镇","621026104":"和盛镇","621026105":"湘乐镇","621026106":"新庄镇","621026107":"盘克镇","621026108":"中村镇","621026109":"焦村镇","621026110":"米桥镇","621026111":"良平镇","621026112":"太昌镇","621026113":"春荣镇","621026205":"南义乡","621026206":"瓦斜乡","621026207":"金村乡","621026208":"九岘乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621026.json
// module id = 2945
// module chunks = 0